import getUrlParameter from './get-url-parameter'
import isDefined from './is-defined'
import logger from './logger'

export default function initConfig() {
  window._eightselect_config = { ...(window._eightselect_config || {}) }
  const config = {
    merchant: {
      apiId: process.env.TENANT_ID,
      isBlacklisted: isDefined(window._eightselect_config.blacklist) ? window._eightselect_config.blacklist : false,
    },
    imageCdn: {
      // will be set via MCON widget-manager for now
      ...(window._eightselect_config.imageCdn || {
        host: null,
      }),
    },
    eightlytics: {
      url: process.env.EIGHTLYTICS_URL,
      ...(window._eightselect_config.eightlytics || {}),
    },
    lazyloading: isDefined(window._eightselect_config.lazyloading) ? window._eightselect_config.lazyloading : false,
    sysButton: {
      dynamic: isDefined(window._eightselect_config.dynamicSysButton)
        ? window._eightselect_config.dynamicSysButton
        : window._eightselect_config.lazyloading === false || true,
    },
    apiId: window._eightselect_config.apiId || process.env.TENANT_ID,
    version: process.env.VERSION,
    featureFlags: window._eightselect_config.featureFlags || {}, // observeDOM
  }

  if (config.featureFlags.observeDOM === true && !window.MutationObserver) {
    logger('featureFlag observeDOM enabled but MutationObserver not available. Falling back to default.')
    config.featureFlags.observeDOM = false
  }

  config.widgets = {}
  if (isDefined(window._eightselect_config.widgets)) {
    config.widgets = window._eightselect_config.widgets
  }

  config.merchant.host = window.location.host
  config.merchant.url = window.location.href

  config.hooks = {
    ...(window._eightselect_config.hooks || {}),
  }

  config.demoMode = {
    isActive: function() {
      return (
        getUrlParameter('8s_demo') !== undefined ||
        getUrlParameter('8S-demo') !== undefined ||
        window._eightselect_config.isDemoMode === true
      )
    },

    apiId: 'db54750f-80fc-4818-9455-30ca233225dc',
    setId: 'e3bcaf66-5037-4d7b-be4a-8c571a6fb299',
    sku: '8S-DEMO-Polohemd-1',
    tags: 'demo',
    ...(window._eightselect_config.demoMode || {}),
  }

  config.apis = {
    apiId: config.demoMode.isActive() ? config.demoMode.apiId : config.merchant.apiId,
  }

  return config
}
